// Copyright (c) Docugami, Inc. All rights reserved.**/

import { ReportDocumentNavButton } from "components/work_path/ReportDocumentNavButton";
import { AbstractView } from "components/reports/AbstractView";
import { appBackgroundGrey } from "components/shell/presentation/AppStyles";
import styled from "styled-components";
import { NavDirection } from "components/common/DocumentNavButton";

// We need to set a min-width on the abstract container to account for
// its children that have set widths (e.g. the canvas is 823px).
// This ensures the container will cover at least its contents
const AbstractViewContainer = styled.div`
    display: flex;
    height: 100%;
    background: ${appBackgroundGrey};
    align-items: center;
    justify-content: center;
    min-width: 1100px;
`

interface AbstractPreviewProps {
    workPathName: string;
    targetDocumentId: string;
    documentIds?: string[];
}

export const AbstractPreview = ({ documentIds, targetDocumentId, workPathName }: AbstractPreviewProps) => {
    return (
        <AbstractViewContainer>
            <ReportDocumentNavButton
                documentIds={documentIds}
                currentDocumentId={targetDocumentId}
                direction={NavDirection.Left} />
            <AbstractView
                title={workPathName}
                folderId={targetDocumentId} />
            <ReportDocumentNavButton
                documentIds={documentIds}
                currentDocumentId={targetDocumentId}
                direction={NavDirection.Right} />
        </AbstractViewContainer>)
}
